'use client';
import { signIn, signOut, useSession } from 'next-auth/react';

import type { AuthenticationHook } from './use-authentication.types';

export function useAuthentication(): AuthenticationHook {
  const { data, status } = useSession();

  if (status === 'authenticated' && data?.tokenSet && data?.user)
    return {
      status,
      tokenSet: data?.tokenSet,
      user: data?.user,
      signOut,
    };

  if (status === 'unauthenticated')
    return {
      status,
      signIn,
    };

  return {
    status: 'loading',
  };
}
